import { EnumLanguage } from '@libs/constants';

import { FLYING_DISPLATE_LISTING_LIMITATIONS } from './contracts/design-listing-displate.interface';
import { FLYING_GLOBAL_LISTING_LIMITATIONS } from './contracts/design-listing-global.interface';
import { FLYING_MBA_LISTING_LIMITATIONS } from './contracts/design-listing-mba.interface';
import { FLYING_DESIGN_TAG_LIMITATIONS } from './contracts/design.interface';
import { EnumPlatform } from './contracts/print-on-demand.constants';


/**------------------------------------------------------
 * Upload Module Config
 */
export const UPLOAD_CONFIG: IUploadConfig = {
	POD : {
		LANGUAGES : {
			MAX_EDIT_LANGUAGES  : 4,
			MAIN_LANGUAGES      : [EnumLanguage.EN, EnumLanguage.DE, EnumLanguage.FR, EnumLanguage.ES, EnumLanguage.IT],
			EDIT_LANGUAGES      : [EnumLanguage.EN, EnumLanguage.DE, EnumLanguage.FR, EnumLanguage.ES, EnumLanguage.IT],
			MBA_LANGUAGES		: [EnumLanguage.EN, EnumLanguage.DE, EnumLanguage.FR, EnumLanguage.IT, EnumLanguage.ES, EnumLanguage.JA],
			ASSISTANT_LANGUAGES : [
				EnumLanguage.AR, EnumLanguage.NL, EnumLanguage.EN, EnumLanguage.FI, EnumLanguage.FR, EnumLanguage.DE, EnumLanguage.HI,
				EnumLanguage.ID, EnumLanguage.IT, EnumLanguage.JA, EnumLanguage.KO, EnumLanguage.ZH, EnumLanguage.PL, EnumLanguage.PT,
				EnumLanguage.RU, EnumLanguage.ES, EnumLanguage.SV, EnumLanguage.TH, EnumLanguage.TR, EnumLanguage.VI
			]
		},
		PLATFORMS : [
			EnumPlatform.Redbubble, EnumPlatform.SpreadshirtUS,  EnumPlatform.SpreadshirtEU,  EnumPlatform.Teepublic, /* EnumPlatform.Teespring, */
			EnumPlatform.Tostadora, EnumPlatform.FineArtAmerica, EnumPlatform.Printful,  EnumPlatform.Printify,
			/* EnumPlatform.Shirtee, */   EnumPlatform.MBA, 	 EnumPlatform.Displate
		],
		LISTING_LIMITATIONS: {
			META : {
				TAGS		: FLYING_DESIGN_TAG_LIMITATIONS.MAX_TAGS
			},
			GLOBAL : {
				TITLE		: FLYING_GLOBAL_LISTING_LIMITATIONS.TITLE_LENGTH,
				DESCRIPTION	: FLYING_GLOBAL_LISTING_LIMITATIONS.DESCRIPTION_LENGTH,
				KEYWORDS	: FLYING_GLOBAL_LISTING_LIMITATIONS.KEYWORD_LENGTH
			},
			MBA : {
				BRAND		: FLYING_MBA_LISTING_LIMITATIONS.BRAND_LENGTH,
				TITLE		: FLYING_MBA_LISTING_LIMITATIONS.TITLE_LENGTH,
				BULLET1		: FLYING_MBA_LISTING_LIMITATIONS.BULLET1_LENGTH,
				BULLET2		: FLYING_MBA_LISTING_LIMITATIONS.BULLET2_LENGTH,
				DESCRIPTION	: FLYING_MBA_LISTING_LIMITATIONS.DESCRIPTION_LENGTH,
				COLORS		: FLYING_MBA_LISTING_LIMITATIONS.MAX_COLORS
			},
			DISPLATE : {
				TITLE		: FLYING_DISPLATE_LISTING_LIMITATIONS.TITLE_LENGTH,
				DESCRIPTION	: FLYING_DISPLATE_LISTING_LIMITATIONS.DESCRIPTION_LENGTH,
				KEYWORDS	: FLYING_DISPLATE_LISTING_LIMITATIONS.KEYWORD_LENGTH,
				COLLECTION	: FLYING_DISPLATE_LISTING_LIMITATIONS.COLLECTION_LENGTH,
				CATEGORIES	: FLYING_DISPLATE_LISTING_LIMITATIONS.MAX_CATEGORIES
			}
		},
		DESIGN_BACKGROUNDS: {
			DESIGNS 	: {
				LIGHT 		: '#d3d3d3',
				DARK  		: '#202020'
			},
			EDIT 		: {
				GLOBAL: {
					WHITE 	: '#f6f6f6',
					BLACK	: '#202020',
					COLORFUL: '#ababab'
				},
				DISPLATE : {
					WHITE 	: '#f6f6f6',
					BLACK	: '#000000'
				}
			}
		},
		MAX_UPLOAD_SIZE_BYTES: 1073741824		// 1 GB max size
	},
	KDP : {
		LANGUAGES: {
			MAIN_LANGUAGES      : [EnumLanguage.EN, EnumLanguage.DE, EnumLanguage.FR, EnumLanguage.ES, EnumLanguage.JA],
			ASSISTANT_LANGUAGES : [
				EnumLanguage.AR, EnumLanguage.NL, EnumLanguage.EN, EnumLanguage.FI, EnumLanguage.FR, EnumLanguage.DE,
				EnumLanguage.HI, EnumLanguage.ID, EnumLanguage.IT, EnumLanguage.JA, EnumLanguage.KO, EnumLanguage.ZH,
				EnumLanguage.PL, EnumLanguage.PT, EnumLanguage.RU, EnumLanguage.ES, EnumLanguage.SV, EnumLanguage.TH,
				EnumLanguage.TR, EnumLanguage.VI
			]
		},
		PLATFORMS: [EnumPlatform.KDP]
	},
	LIMITATIONS : {
		MAX_DESIGNS_EDIT 			: 500,
		MAX_DESIGNS_TM_CHECK		: 500
	},
	MAX_HAMMING_DISTANCE	: 10
};


/**------------------------------------------------------
 * Interfaces Definitions
 */
interface IUploadConfig {
	POD : {
		LANGUAGES : {
			MAX_EDIT_LANGUAGES  : number;
			MAIN_LANGUAGES      : EnumLanguage[];
			EDIT_LANGUAGES      : EnumLanguage[];
			MBA_LANGUAGES		: EnumLanguage[];
			ASSISTANT_LANGUAGES : EnumLanguage[];
		};
		PLATFORMS 		 		: EnumPlatform[];
		LISTING_LIMITATIONS		: IUploadPodListingLimitations;
		DESIGN_BACKGROUNDS		: IUploadPodDesignBackground;
		MAX_UPLOAD_SIZE_BYTES	: number;
	};
	KDP : {
		LANGUAGES: {
			MAIN_LANGUAGES      : EnumLanguage[];
			ASSISTANT_LANGUAGES : EnumLanguage[];
		};
		PLATFORMS: EnumPlatform[];
	};
	LIMITATIONS : {
		MAX_DESIGNS_EDIT 			: number;
		MAX_DESIGNS_TM_CHECK		: number;
	};
	MAX_HAMMING_DISTANCE	: number;
}

export interface IUploadPodListingLimitations {
	META : {
		TAGS		: number;
	};
	GLOBAL : {
		TITLE		: number;
		DESCRIPTION : number;
		KEYWORDS	: number;
	};
	MBA : {
		BRAND 		: number;
		TITLE 		: number;
		BULLET1 	: number;
		BULLET2 	: number;
		DESCRIPTION : number;
		COLORS 		: number;
	};
	DISPLATE : {
		TITLE		: number;
		DESCRIPTION : number;
		KEYWORDS	: number;
		COLLECTION	: number;
		CATEGORIES	: number;
	};
}

export interface IUploadPodDesignBackground {
	DESIGNS 	: {							// DESIGN MANAGEMENT
		LIGHT 		: string;
		DARK  		: string;
	};
	EDIT 		: {
		GLOBAL: {
			WHITE 		: string;
			BLACK		: string;
			COLORFUL 	: string;
		};
		DISPLATE : {
			WHITE 		: string;
			BLACK		: string;
		};
	};
}
